import { Component, ViewChild } from "@angular/core";
import { Router } from "@angular/router";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";

import { AppEventNames } from "src/app-client/_appCommon/base/Constants";
import { BroadcastManager } from "src/app-client/_appCommon/base/BroadcastManager";
import { CaseDataService } from "src/app-client/_dataservices/CaseDataService";
import { CaseWizardService } from "src/app-client/_dataservices/CaseWizardService";
import { ControllerBase } from '../../../../../app-admin/_appCommon/base/ControllerBase';
import { ProductDataService } from "src/app-client/_dataservices/ProductDataService";
import { ShoppingCart } from "src/app/shopping-cart";
import { ShoppingCartDataService } from '../../../../_dataservices/ShoppingCartDataService';

@Component({
  selector: 'app-client-case-final-step',
  templateUrl: './case-final-step.component.html',
  styleUrls: ['./case-final-step.component.css'],
  providers: [ProductDataService, CaseDataService]
})
export class CaseFinalStepComponent extends ControllerBase
{
  @ViewChild('productCatalogDialog') protected productCatalogDialog: any;

  public currentCase: any;
  public isProductCatalogStorage: boolean;

  public unsubscribe: Subject<boolean> = new Subject();

  constructor(
    private caseDataService: CaseDataService,
    private productDataService: ProductDataService,
    private router: Router,
    private shoppingCart: ShoppingCart,
    public caseWizardDataService: CaseWizardService,
    private shoppingCartDataService:ShoppingCartDataService
  )
  {
    super();
  }

  ngOnInit(): void
  {
    this.currentCase = this.caseWizardDataService.getCurrentCase();

    BroadcastManager.Instance.on(AppEventNames.onSelectPurchasedProduct)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(([response]) =>
      {
        this.onSetProductToCase(response[0]);
      });
  }

  ngOnDestroy(): void
  {
    this.unsubscribe.next(true);
    this.unsubscribe.unsubscribe();
  }

  public buyNewProductClicked(): void
  {
    this.shoppingCartDataService.caseId = this.currentCase.id;
    this.shoppingCartDataService.casePatientName = this.currentCase.patientFullName;
    this.shoppingCart.caseId = this.currentCase.id;
    this.productDataService.setProductListCategoryId(1); // Caso = 1
    this.isProductCatalogStorage = true;
    this.productCatalogDialog.show = !this.productCatalogDialog.show;
  }

  getPurchasedProducts(): void
  {
    this.isProductCatalogStorage = false;
    this.productCatalogDialog.show = !this.productCatalogDialog.show;
  }

  public onSetProductToCase(orderDetail: any): void
  {
    let body =
    {
      caseId: this.currentCase.id,
      productId: orderDetail.productId,
      orderDetailId: orderDetail.id,
    };

    this.caseDataService.updateProductId(body)
      .subscribe((response) =>
      {
        this.productCatalogDialog.show = false;
        this.setSuccessAlert("Paquete agregado al caso satisfactoriamente");
        this.onGoToCaseDetail();
      }, (fail) =>
      {
        this.setDangerAlert(fail.error.message);
      });
  }

  public onGoToCaseDetail(): void
  {
    this.router.navigate(['/ecommerce/mis-casos/detail/', this.currentCase.id]);
  }
}
